import { useState } from "react";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { MEMBER_LOGIN_URL, LOGO } from "../../lib/site";
import { trackEvent } from "../../lib/analytics";
import { PrimaryButton } from "./Buttons";

export const PORTAL_LIVE = typeof MEMBER_LOGIN_URL === "string" && MEMBER_LOGIN_URL.startsWith("http");

export const MemberLoginAction = ({ render }) => {
  const [open, setOpen] = useState(false);
  if (PORTAL_LIVE) {
    return render({
      href: MEMBER_LOGIN_URL,
      onClick: () => trackEvent("member_login_click"),
    });
  }
  return (
    <>
      {render({ onClick: (e) => { e.preventDefault(); trackEvent("member_login_click"); setOpen(true); } })}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="portal-coming-soon-dialog"
          className="bg-[#041525] border border-[#009BFF]/30 text-white max-w-md rounded-2xl p-10 text-center"
        >
          <img src={LOGO} alt="MST" className="h-10 w-auto mx-auto" />
          <div className="mt-2 w-14 h-14 mx-auto rounded-full bg-[#009BFF]/10 border border-[#009BFF]/30 flex items-center justify-center">
            <Lock size={24} strokeWidth={1.5} className="text-[#00C4F4]" />
          </div>
          <DialogTitle
            className="mt-4 text-2xl font-extrabold tracking-tight text-white"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Member Portal Coming Online
          </DialogTitle>
          <DialogDescription className="mt-2 text-sm text-[#B7C0CC] leading-relaxed">
            The MST private member portal is currently being finalized. Please check back shortly.
          </DialogDescription>
          <div className="mt-6">
            <PrimaryButton data-testid="portal-dialog-close-btn" onClick={() => setOpen(false)} className="w-full">
              Understood
            </PrimaryButton>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
